import React from 'react';
import { TextField, NumberField } from 'react-admin';

import Datagrid from '../common/Datagrid';
import DateField from '../common/fields/DateField';
import ResourceLinkField from '../common/fields/ResourceLinkField';
import RecordSplitButton from '../common/buttons/RecordSplitButton';


const BudgetRow = ({ children, ...props }) => (
    <Datagrid {...props}>
        <ResourceLinkField label="Label" sortBy="label" resource="budgets">
            <TextField source="label" />
        </ResourceLinkField>
        <ResourceLinkField label="Customer" source="customer" resource="customers" sortBy="customer_id">
            <TextField source="name" />
        </ResourceLinkField>
        <ResourceLinkField label="Project" source="project" resource="projects" sortBy="project_id">
            <TextField source="name" />
        </ResourceLinkField>
        <TextField source="alias" />
        <NumberField source="hours_included" label="Hours"/>
        <TextField source="amount" />
        <DateField source="updated_at" />
        <RecordSplitButton />
        {children}
    </Datagrid>
);

export default BudgetRow;